
import React, { useState, useEffect, useContext } from "react";


import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import ScannerComponent from './scannerComponent'; // adjust the path if needed
// adjust the path if needed

import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import moment from "moment";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import './scan.css';

let { lambda, appname } = window.app

const Scan = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { search } = state || {};
    const [toggle, setToggle] = useState(false);
    // const [data, setData] = useState([]);
    // const [userdata, setUserData] = useState([]);
    const [user, setUser] = useState("");
    const [storeData, setStoreData] = useState([]);
    const [countsData, setCountsData] = useState([]);
    const [editUser, setEditUser] = useState({});
    // const [perpage, setPerpage] = useState(10);
    // const [arrow, setArrow] = useState(0);
    const [perpage, setPerpage] = useState(10);
    const [scannerKey, setScannerKey] = useState(Date.now());
    // const [currentPage, setcurrentPage] = useState(1);
    const [itemsPerPage, setitemsPerPage] = useState(10);

    const [pageNumberLimit, setpageNumberLimit] = useState(5);
    const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
    const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [tableErrMsg, setTableErrMsg] = useState(false);
    const [image, setImg] = useState('')
    const [arrowdir, setArrowDir] = useState('down');
    const [num, setNum] = useState();
    // const [sortDirection, setSortDirection] = useState('asc');

    const [scanChange, setScanChange] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);



    let id = localStorage.getItem("userId");
    let storeid = localStorage.getItem("storeid")
    const [flag, setFlag] = useState(false);

    // const [isLoading, setIsLoading] = useState(false); 
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, isRefreshed, setIsRefreshed, userData, clientInfo, setUserData, GetClientDataContext, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu === "User Management")
    const subValDashboard = validateObj && validateObj[0] && validateObj[0].dashboard
    // // console.log('validate obj', validateObj)

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute != route) {
            setCurrentPage(1)
            setRowsPerPage(15)
            setSearchedFlag(false);
            setUserSearch("")
        }
    }, [prevRoute]);

    useEffect(() => {

        const storeIdLocal = localStorage.getItem("storeid");
        if (storeIdLocal) {
            setEditUser((prev) => ({
                ...prev,
                store: storeIdLocal
            }));
            defaultstoreCounts(storeIdLocal);
            getStore()
        } else {
            getStore()
        }
    }, []);
    useEffect(() => {
        setRoute("user")
        //  GetUserData();
        setActiveMenuId(200006)
        // setActiveMenuObj({
        //     "Client Management": false,
        //     "Contact Management": false,
        //     "Reports": false
        // })
        // userActivity();
    }, []);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);



    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/signin");
            return;
        }

        // Skip if clientInfo is still empty
        if (!clientInfo?.subscriptionPayment) return;

        if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
            navigate("/signin");
        }
    }, [clientInfo, navigate]);

    // useEffect(() => {

    //     getStore()


    //     if (storeid) {
    //         defaultstoreCounts(storeid)
    //     }

    // }, []);
    useEffect(() => {

        if (!storeid) return;

        // Call immediately
        defaultstoreCounts(storeid);

        // Set interval
        const interval = setInterval(() => {
            defaultstoreCounts(storeid);
        }, 120000); // 2 minutes

        // Cleanup on unmount
        return () => clearInterval(interval);
    }, [storeid]);

    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }

    }, []);

    // SCRUM-358: walk-ins are no longer blocked at capacity. isDisabled now only guards
    // against double-submitting while a walk-in request is in flight.


    const getStore = (e) => {
        // console.log("result", "result")
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        const useruniqueid = localStorage.getItem("clientid")
        // const userdata = localStorage.getItem("userdata")
        // // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        // // console.log('userToken--->',userToken)
        axios({
            method: 'POST',
            url: `${lambda}/getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result.length > 0) {
                        const result = response?.data?.result;
                        // console.log("result", result)

                        const storeIdLocal = localStorage.getItem("storeid");
                        if (!storeIdLocal) {
                            if (result && result?.[0]?.storeid) {
                                setEditUser((prev) => ({
                                    ...prev,
                                    store: result?.[0]?.storeid
                                }));
                                defaultstoreCounts(result?.[0]?.storeid);
                                localStorage.setItem("storeid", result?.[0]?.storeid);
                                localStorage.setItem("storename", result?.[0]?.name);
                            }
                        }



                        setStoreData(result)
                        //  editUser?.companydetails?.[0].accountmanager
                    }

                }

                // setDisableSaveBtn(false)
            });
    }
    const defaultstoreCounts = (value) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        const useruniqueid = localStorage.getItem("clientid")
        // let storeid = localStorage.getItem("storeid") || value
        //const storeid = localStorage.getItem("storeid")
        // const userdata = localStorage.getItem("userdata")
        // // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        //// console.log('editUser12121212--->',editUser?.store)
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = moment.tz(timeZone).format("MM-DD-YYYY");
        console.log("date--->", date);


        axios({
            method: 'GET',
            url: `${lambda}/storeCounts?appname=${appname}&storeid=${value}&token=${token}&timeZone=${timeZone}&date=${date}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result) {
                        const result = response?.data?.result;
                        setCountsData(result)
                        //  editUser?.companydetails?.[0].accountmanager
                    }

                }

                // setDisableSaveBtn(false)
            });
    }

    // const handleChange = (e) => {
    //     const { name, value } = e.target;

    //     let parsedValue;
    //     try {
    //         parsedValue = JSON.parse(value);
    //     } catch (err) {
    //         console.error("Invalid JSON value in select option", err);
    //         return;
    //     }

    //     const { id, name: storeName } = parsedValue;

    //     // console.log("Selected Store ID:", id);

    //     localStorage.setItem("storeid", id);
    //     localStorage.setItem("storename", storeName);

    //     setEditUser((prev) => ({
    //         ...prev,
    //         [name]: id
    //     }));

    //     if (id) {
    //         storeCounts(id);
    //     }
    // };


    const handleChange = (e) => {
        const { name, value } = e.target;

        const selectedStore = storeData.find((store) => store.storeid.toString() === value);
        if (!selectedStore) return;

        localStorage.setItem("storeid", selectedStore.storeid);
        localStorage.setItem("storename", selectedStore.name);

        setEditUser((prev) => ({
            ...prev,
            [name]: selectedStore.storeid,
        }));

        storeCounts(selectedStore.storeid);
        setScannerKey(Date.now());
    };
    const storeCounts = (value) => {
        // GetTimeActivity()
        const token = localStorage.getItem("token")
        const useruniqueid = localStorage.getItem("clientid")
        //let storeid = localStorage.getItem("storeid") || value
        //const storeid = localStorage.getItem("storeid")
        // const userdata = localStorage.getItem("userdata")
        // // console.log('userdata--->',userdata.username)
        // let userToken = userdata && userdata.token
        //// console.log('editUser12121212--->',editUser?.store)
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const date = moment.tz(timeZone).format("MM-DD-YYYY");
        console.log("date--->", date);
        axios({
            method: 'GET',
            url: `${lambda}/storeCounts?appname=${appname}&storeid=${value}&token=${token}&timeZone=${timeZone}&date=${date}`,
            // + "&token=" + token,
        })
            .then(function (response) {
                if (response?.data?.result === "Invalid token or Expired") {
                    setShowSessionPopupup(true)
                } else {
                    if (response?.data?.result) {
                        const result = response?.data?.result;
                        // if(result?.walkinCompleted !== 0){

                        // }
                        setCountsData(result)
                        //  editUser?.companydetails?.[0].accountmanager
                    }

                }

                // setDisableSaveBtn(false)
            });
    }


    const handleScanChange = (newValue) => {
        setScanChange(newValue);
    };

    // // console.log("editUser", editUser, countsData)
    const walkInClick = async (e) => {
        setIsDisabled(true);
        let storeidvalue = localStorage.getItem("storeid")
        let storeid = (editUser?.store || storeidvalue)
        setIsLoading(true);
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            const response = await axios.post(`${lambda}/walkIn?appname=${appname}&storeid=${storeid}&token=${token}`, {
                type: "WalkIn",
                automatedExit: countsData?.automatedExit,
                visitDuration: countsData?.visitDuration
            });
            if (response?.data?.result?.length > 0) {
                // SCRUM-358: capacity never blocks a walk-in. The refreshed counts recolor
                // the capacity indicator (green/orange/red); there is no capacity pop-up.
                storeCounts(storeid)
                setIsLoading(false);
                setIsDisabled(false);
            }

        } catch (error) {
            console.error("Error fetching categories:", error);
            setIsLoading(false);
            setIsDisabled(false);
        }

    };
    let storename = localStorage.getItem("storename")
    let singleCount = (countsData?.walkin || 0) + (countsData?.visitorCount || 0);

    // SCRUM-358: real-time capacity indicator. Capacity never blocks scanning, so this is
    // purely informational — green under capacity, orange at capacity, red over capacity.
    // Colors are inline (not stat-badge classes) because the badge palette is defined in the
    // CDN stylesheet and has no red variant.
    const capacityLimit = Number(countsData?.maxLocationCapacity) || 0;
    const capacityBadgeStyle =
        capacityLimit <= 0
            ? { backgroundColor: '#E0E7FF', color: '#3730A3' }        // capacity not set → neutral
            : singleCount < capacityLimit
                ? { backgroundColor: '#DCFCE7', color: '#15803D' }    // green: under capacity
                : singleCount === capacityLimit
                    ? { backgroundColor: '#FFEDD5', color: '#C2410C' } // orange: at capacity
                    : { backgroundColor: '#FEE2E2', color: '#B91C1C' }; // red: over capacity

    return (
        <>
            {showSessionPopupup && <SessionPopup />}

            <div id="layout-wrapper">
                <Header />
                <Sidebar />

                {/* Start right Content here  */}

                <div className="main-content user-management scan-page" id="scan-main-content">

                    <div className="page-content" id="scan-page-content">
                        <div className="container-fluid" id="scan-container-fluid">

                            <div className="row breadcrumb" id="scan-breadcrumb-row">
                                <div className="col-lg-12" id="scan-col-lg-12">
                                    <div className="d-flex align-items-center" id="scan-align-items-center">

                                        <div className="flex-grow-1" id="scan-flex-grow-1">
                                            <h4 className="mb-2 card-title" id="scan-title">SCAN</h4>
                                        </div>

                                        <div className="col-md-4 ps-3" id="scan-col-md-4">
                                            <div className="input_group_wrapper" id="scan-input-group-wrapper">
                                                <label className="form_label" htmlFor="scan-store-select" id="scan-label-store-select">
                                                    Select Store<span className="required">*</span>
                                                </label>
                                                <div className="input_group" id="scan-input-group">
                                                    <div className="icon_wrapper" id="scan-icon-wrapper">
                                                        <span className="material-symbols-outlined">store</span>
                                                    </div>
                                                    <select
                                                        className="form-select form-control"
                                                        name="store"
                                                        onChange={handleChange}
                                                        id="scan-store-select"
                                                        value={editUser?.store || ""}
                                                    >
                                                        <option value="">Select Store</option>
                                                        {storeData &&
                                                            storeData.map((store, index) => (
                                                                <option
                                                                    key={store.storeid || index}
                                                                    value={store.storeid}
                                                                >
                                                                    {store.name}
                                                                </option>
                                                            ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="row scan-page" id="scan-row">
                                <div className="row scan-page scan-card-row" id="scan-row">
                                   
                                    <div className="col-6 col-md-3">
                                        <div className="card scaning-card">
                                            <div className="stat-badge pink">
                                                {singleCount}
                                            </div>
                                            <h6 className="stat-title">Visitors in Location</h6>
                                        </div>
                                    </div>
                                   
                                    <div className="col-6 col-md-3">
                                        <div className="card scaning-card">
                                            <div className="stat-badge green">
                                                {countsData?.forecast30min || 0}
                                            </div>
                                            <h6 className="stat-title">Forecast in 30min</h6>
                                        </div>
                                    </div>
                                    
                                    {/* <div className="col-6 col-md-3">
                                        <div className="card scaning-card">
                                            <div className="stat-badge green">
                                                {countsData?.bookingExpired || 0}
                                            </div>
                                            <h6 className="stat-title">Spots Expired</h6>
                                        </div>
                                    </div> */}

                                    
                                    <div className="col-6 col-md-3">
                                        <div className="card scaning-card">
                                            <div className="stat-badge orange">
                                                {countsData?.maxVisitor || 0}
                                            </div>
                                            <h6 className="stat-title">Maximum Visitors</h6>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-3">
                                        <div className="card scaning-card">
                                            <div className="stat-badge" style={capacityBadgeStyle}>
                                                {singleCount !== 0 && countsData?.maxLocationCapacity
                                                    ? `${singleCount}/${countsData.maxLocationCapacity}`
                                                    : countsData?.maxLocationCapacity || 0}
                                            </div>
                                            <h6 className="stat-title">Maximum Location Capacity</h6>
                                        </div>
                                    </div> </div>

                                {/* <div className="scan-stats-grid">

                                    <div className="card scaning-card">
                                        <div className="stat-badge pink">{singleCount}</div>
                                        <h6 className="stat-title">Visitors in Location</h6>
                                    </div>

                                    <div className="card scaning-card">
                                        <div className="stat-badge green">{countsData?.bookingExpired || 0}</div>
                                        <h6 className="stat-title">Spots Expired</h6>
                                    </div>

                                    <div className="card scaning-card">
                                        <div className="stat-badge green">{countsData?.forecast30min || 0}</div>
                                        <h6 className="stat-title">Forecast (30 min)</h6>
                                    </div>

                                    <div className="card scaning-card">
                                        <div className="stat-badge orange">{countsData?.maxVisitor || 0}</div>
                                        <h6 className="stat-title">Maximum Visitors</h6>
                                    </div>

                                    <div className="card scaning-card">
                                        <div className="stat-badge blue">
                                            {singleCount !== 0 && countsData?.maxLocationCapacity
                                                ? `${singleCount}/${countsData.maxLocationCapacity}`
                                                : countsData?.maxLocationCapacity || 0}
                                        </div>
                                        <h6 className="stat-title">Max Location Capacity</h6>
                                    </div>



                                </div> */}

                                <div className="col-md-12 mt-3" id="scan-col-md-12-walkin-button">
                                    <div className="card full-height-card" id="scan-card-walkin-button">
                                        <div className="card-body" id="scan-card-body-walkin-button">
                                            <div className="container-fluid" id="scan-container-fluid-walkin-button">
                                                <div className="row" id="scan-row-walkin-button">
                                                    <div className="col-12" id="scan-col-12-walkin-button">
                                                        <div className="page-center" id="scan-page-center">
                                                            <div className="video-wrapper" id="scan-video-wrapper">
                                                                <div id="scan-scanner-wrapper">
                                                                    <ScannerComponent
                                                                        countsData={countsData}
                                                                        key={scannerKey}
                                                                        onScanChange={handleScanChange}
                                                                        defaultstoreCounts={defaultstoreCounts}
                                                                        id="scan-scanner-component"
                                                                    />

                                                                    {scanChange == false && (
                                                                        <div className="col-md-12" id="scan-col-md-12-walkin-btn-card">
                                                                            <div className="card" id="scan-walkin-card">
                                                                                <div className="card-body" id="scan-walkin-card-body">
                                                                                    <div className="d-flex justify-content-center align-items-center" id="scan-walkin-btn-wrapper">
                                                                                        {(storeid || editUser?.store) && (
                                                                                            <button
                                                                                                className="fill-btn-style"
                                                                                                id="scan-add-store-button"
                                                                                                onClick={(e) => walkInClick(e)}
                                                                                                disabled={isDisabled}
                                                                                                style={{
                                                                                                    backgroundColor: isDisabled ? '#cccccc' : '#6c2bd9',
                                                                                                    color: '#ffffff',
                                                                                                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                                                                                                    border: 'none',
                                                                                                    padding: '10px 20px',
                                                                                                    fontSize: '16px',
                                                                                                    borderRadius: '10px',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    justifyContent: 'center',
                                                                                                    gap: '8px',
                                                                                                }}
                                                                                            >
                                                                                                {isLoading ? (
                                                                                                    <img
                                                                                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                                                                                        className="loading-icon"
                                                                                                        alt="Loading"
                                                                                                        id="scan-loading-icon"
                                                                                                    />
                                                                                                ) : null}
                                                                                                <span className="material-symbols-outlined">directions_walk</span>WALK IN
                                                                                            </button>
                                                                                        )}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                            </div>
                        </div>
                    </div>

                    <SweetAlert
                        show={tableErrMsg}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"Something went wrong. Please reload again."}
                        onConfirm={e => setTableErrMsg(false)}
                        id="scan-error-alert"
                    />

                    <Footer id="scan-footer" />

                </div>




            </div>

        </>
    );
};

export default Scan;
